import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
interface TrustBadgesProps {
  variant?: 'light' | 'dark';
  className?: string;
}
export function TrustBadges({
  variant = 'light',
  className = ''
}: TrustBadgesProps) {
  const text = variant === 'light' ? 'text-brand-slate' : 'text-white';
  const shield = variant === 'light' ? 'text-brand-magenta' : 'text-brand-gold';
  return <div className={`flex flex-col sm:flex-row justify-center items-center gap-0.5 sm:gap-4 text-[11px] sm:text-xs font-bold ${text} ${className}`} data-id="element-150" data-mp="3cfxaiq9yil5q">
      <span data-id="element-151" data-mp="37gu4p3m5kawp">⭐ 4,9/5 — Avis vérifiés de professeurs de gymnastique rythmique</span>
      <span className="flex items-center gap-1 text-center" data-id="element-152" data-mp="3l77df86vbtn3">
        <ShieldCheckIcon className={`w-3.5 h-3.5 shrink-0 ${shield}`} data-id="element-153" data-mp="3h75h7ejwjsf7" />
        🛡️ Garantie satisfait ou remboursé pendant 7 jours — Zéro risque
      </span>
    </div>;
}